import React from 'react';
import PropTypes from 'prop-types';

const ConfirmModal = (props) => {
    const { description } = props;

    return (
        <p>{ description }</p>
    );
};

ConfirmModal.propTypes = {
    description: PropTypes.string,
};

export default ConfirmModal;



// WEBPACK FOOTER //
// ./src/components/modals/types/ConfirmModal.js